import script from "./ChangePasswordForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangePasswordForm.vue?vue&type=script&setup=true&lang=ts"

import "./ChangePasswordForm.vue?vue&type=style&index=0&id=19f251e4&scoped=true&lang=css"

import exportComponent from "/var/www/rentasdhelos.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19f251e4"]])

export default __exports__